import { render, staticRenderFns } from "./PrintingExpenses.vue?vue&type=template&id=708beafa&scoped=true"
import script from "./PrintingExpenses.vue?vue&type=script&lang=js"
export * from "./PrintingExpenses.vue?vue&type=script&lang=js"
import style0 from "./PrintingExpenses.vue?vue&type=style&index=0&id=708beafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708beafa",
  null
  
)

export default component.exports